import { FilterGroup } from '../../../features/browse-index/models';

export const LIBRARIES_FILTER_GROUPS_CONFIG: Omit<FilterGroup, 'options' | 'selectedValues' | 'page' | 'hasMore' | 'loading' | 'totalCount' | 'searchTerm'>[] = [
  {
    key: 'name',
    label: 'FILTERS.INSTITUTION',
    field: 'name',
    searchable: true,
    expanded: true,
    pageSize: 5,
  },
  {
    key: 'city',
    label: 'FILTERS.CITY',
    field: 'city',
    searchable: true,
    expanded: true,
    pageSize: 5,
  },
  {
    key: 'country',
    label: 'FILTERS.COUNTRY',
    field: 'country',
    searchable: true,
    expanded: true,
    pageSize: 5,
  },
];

export const LIBRARIES_SEARCH_DEBOUNCE_MS = 300;
export const LIBRARIES_DEFAULT_PAGE_SIZE = 9;
